import * as yup from 'yup';

const schema = yup.object().shape({
  time_slots: yup.object().typeError('Please fill all the time slots').test('fromTimeValidation', 'End time should be later than start time', (timeSlot) => {
    return timeSlot.start_datetime <= timeSlot.end_datetime;
  }),
});

export default schema;
